import React, { Component } from 'react'
import { Dialog } from '@material-ui/core'
import { connect } from 'react-redux'
import { GetBaseUrl } from '@/utils/ConfigHelper'

import InputField from '@/Common/NewForm/InputField'
import Checkbox from '@/Common/NewForm/Checkbox'
import CloseButton from '@/Common/CloseButton'

import OneBtnDialog from '@/Common/OneBtnDialog/OneBtnDialog'

import PasswordForgot from './PasswordForgotDialog'

import { GetLoginProviders } from '../../utils/SignupProviders'
import { SetIsShowSignUpDialog, Login as LoginFunc } from '../../Interface'
import { ErrorHandler } from "@/utils/Error/Handler"
import { PUBLIC_ERROR_CODE } from "@/utils/Error/Constants"

import i18n from '../../i18n'
import './index.scss'

class LoginDialog extends Component {
    state = {}

    initState = () => {
        this.setState({
            email: "",
            password: "",

            isPermanent: false, // 동작 없음

            isShowEmailBottomAlert: false,
            isShowPasswordBottomAlert: false,

            isOneBtnDialogOpen: false,
            oneBtnDialogType: "failLogin",
            subBodyText: null,

            isPasswordForgotDialogOpen: false
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open) this.initState()
    }

    handleChangeInput = e => this.setState({ [e.target.name]: e.target.value })
    handleChangeCheckbox = e => this.setState({ [e.target.name]: e.target.checked })

    handleClickOneBtnDialogOpen = type => this.setState({ oneBtnDialogType: type, isOneBtnDialogOpen: true }) 
    handleClickOneBtnDialogClose = () => this.setState({ isOneBtnDialogOpen: false })

    handleBlurInput = e => {
        const { name, value } = e.target
        switch (name) {
            case 'email':
                this.setState({ isShowEmailBottomAlert: Boolean(!value || !value.length === 0) })
                break

            case 'password':
                this.setState({ isShowPasswordBottomAlert: Boolean(!value || !value.length === 0) })
                break

            default: break
        }
    }

    handleKeyPress = e => {
        if (e.key === 'Enter') this.login()
    }

    login = async () => {
        const { onClose, handleLoginSuccess } = this.props
        const { email, password } = this.state
        try {
            await LoginFunc(email, password)
            if (typeof handleLoginSuccess === 'function') await handleLoginSuccess()
            onClose()
        }
        catch (e) {
            const excludeCode = [
                PUBLIC_ERROR_CODE.HTTP_STATUS_400,
                PUBLIC_ERROR_CODE.HTTP_STATUS_401,
                PUBLIC_ERROR_CODE.ERR_INVALID_ACCESS_AGENCY,
            ]
            const publicErrorCode = await ErrorHandler(this, email, e, {
                server: true,
                log: true
            }, {
                server: excludeCode
            })
            switch (publicErrorCode) {
                case PUBLIC_ERROR_CODE.HTTP_STATUS_400:
                case PUBLIC_ERROR_CODE.HTTP_STATUS_401:
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "checkInfo",
                        subBodyText: null
                    })
                    break;
                    
                case PUBLIC_ERROR_CODE.ERR_INVALID_ACCESS_AGENCY:
                default:
                    this.setState({
                        isOneBtnDialogOpen: true,
                        oneBtnDialogType: "failLogin",
                        subBodyText: `(code : ${publicErrorCode})`
                    })
                    break;
            }
        }
    }

    renderProviders = item => {
        const {
            className,
            icon,
            endpoint
        } = item

        return (
            <div className={`icon-wrapper ${className}`}>
                <img
                    src={icon}
                    alt=""
                    onClick={() => this.props.handleClickThirdPartyLogin(`${GetBaseUrl()}/${endpoint}`)}
                />
            </div>
        )
    }

    render() {
        const { open, onClose, lang } = this.props
        const {
            email,
            password,
            isPermanent,

            isShowEmailBottomAlert,
            isShowPasswordBottomAlert,

            isOneBtnDialogOpen,
            oneBtnDialogType,
            subBodyText,

            isPasswordForgotDialogOpen
        } = this.state

        const loginProviders = GetLoginProviders(lang)

        return (
            <Dialog open={open} onClose={onClose}>
                <div className="login-dialog-root-container">
                    <div className="close-btn" onClick={onClose}>
                        <CloseButton />
                    </div>
                    <img className="login-dialog-logo" src="https://front.videomonster.com/images-u6yd72dy/common/v2-logo.svg" alt="" />
                    <div className="form-container">
                        <div className="input-wrapper">
                            <InputField
                                type="text"
                                name="email"
                                value={email}
                                placeholder={i18n.t("global.email")}
                                onChange={this.handleChangeInput}
                                onBlur={this.handleBlurInput}
                                onKeyPress={this.handleKeyPress}
                                maxLength={100}
                                isShowBottomText={isShowEmailBottomAlert}
                                bottomText={i18n.t("signup.enter.again.email")}
                            />
                        </div>
                        <div className="input-wrapper">
                            <InputField
                                type="password"
                                name="password"
                                value={password}
                                placeholder={i18n.t("global.password")}
                                onChange={this.handleChangeInput}
                                onBlur={this.handleBlurInput}
                                onKeyPress={this.handleKeyPress}
                                maxLength={50}
                                isShowBottomText={isShowPasswordBottomAlert}
                                bottomText={i18n.t("signup.enter.check.password")}
                            />
                        </div>
                        <div className="checkbox-wrapper">
                            <Checkbox
                                checkboxType="rounded"
                                id="is-permanent"
                                name="isPermanent"
                                checked={isPermanent}
                                label={i18n.t("login.remember.id")}
                                onChange={this.handleChangeCheckbox}
                            />
                        </div>
                    </div>
                    <div className="login-button" onClick={this.login}>
                        {i18n.t("global.login")}
                    </div>
                    <div className="login-bottom-options">
                        <span className="left"
                            onClick={() => this.setState({ isPasswordForgotDialogOpen: true })}
                        >
                            {i18n.t("login.find.password")}
                        </span>
                        <span>|</span>
                        <span
                            className="right"
                            onClick={() => {
                                onClose()
                                SetIsShowSignUpDialog(true)
                            }}
                        >
                            {i18n.t("login.signup.email")}
                        </span>
                    </div>
                    <div className="social-login-container">
                        <div className="title">{i18n.t("login.sns.id")}</div>
                        <div className="icon-container">
                            {
                                loginProviders.map(this.renderProviders)
                            }
                        </div>
                    </div>
                </div>

                <OneBtnDialog
                    open={isOneBtnDialogOpen}
                    closeBtn={this.handleClickOneBtnDialogClose}
                    onButtonClick={this.handleClickOneBtnDialogClose}
                    subBodyText={subBodyText}
                    dialogType={oneBtnDialogType}
                />

                <PasswordForgot
                    open={isPasswordForgotDialogOpen}
                    onClose={() => this.setState({ isPasswordForgotDialogOpen: false })}
                    handleClickOneBtnDialogOpen={this.handleClickOneBtnDialogOpen}
                />
            </Dialog>
        )
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps, null)(LoginDialog)